function setContactCookie(url, cookieName) {
  var name = document.getElementById("name").value;
  var email = document.getElementById("email").value;
  var phone = document.getElementById("phone").value;

  const headers = new Headers({
    "Content-Type": "application/json",
    "X-CSRF-TOKEN": document.querySelector("#name").getAttribute("data-token"),
  });
  fetch(url, {
    method: "POST",
    body: JSON.stringify({
      'name': name,
      'phone': phone,
      'email': email,
      'cookieName': cookieName,
    }),
    headers,
  })
    .then(function (response) {
      if (response.status !== 200 || !response.ok)
        throw new Error("Unexpected response: status " + response.status);

      return response.text();
    })
    .then(function (aside) {
      console.log("set cookie");
    })
    .catch(function (error) {
      console.error(error);
    });
}
